// @flow
import YaKlassPage from './YaKlassPage';

export default YaKlassPage;
